import script from "./AiExpertiseSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiExpertiseSection.vue?vue&type=script&setup=true&lang=ts"

import "./AiExpertiseSection.vue?vue&type=style&index=0&id=e453b5ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e453b5ce"]])

export default __exports__